<template>
  <div class="main">
    <div class="sidebar" :style="{ width: show ? '240px' : '0px' }">
      <div class="logo">
        <div class="logo_bg">
          <img src="../assets/logo.png" width="50" height="50" />
        </div>
      </div>
      <el-menu class="el_menus" :default-active="active" router background-color="#A32126" active-text-color="#fff" text-color="#fff" unique-opened :collapse="isCollapse">
        <div v-for="(item1, index1) in menuList" :key="index1">
          <!-- 一级菜单（没有子级菜单） -->
          <el-menu-item :index="item1.menuPath" v-if="item1.children.length == 0">
            <span class="menuname">{{ item1.menuName }}</span>
          </el-menu-item>
          <!-- 一级菜单（有子菜单） -->
          <el-submenu :index="item1.menuPath" v-else>
            <template slot="title">
              <span class="menuname">{{ item1.menuName }}</span>
            </template>
            <!-- 遍历二级菜单 -->
            <div v-for="(item2, index2) in item1.children" :key="index2">
              <!-- 二级菜单（没有三级菜单） -->
              <el-menu-item :index="item2.menuPath" v-if="item2.children.length == 0">
                <span class="menuname">{{ item2.menuName }}</span>
              </el-menu-item>
              <!-- 二级菜单（有三级菜单） -->
              <el-submenu :index="item2.menuPath" v-else>
                <template slot="title">
                  <span class="menuname">{{ item2.menuName }}</span>
                </template>
                <el-menu-item v-for="(item3, index3) in item2.children" :key="index3" :index="item3.menuPath">
                  <span slot="title" class="menuname">{{ item3.menuName }}</span>
                </el-menu-item>
              </el-submenu>
            </div>
          </el-submenu>
        </div>
      </el-menu>
    </div>

    <div class="container" :class="show ? 'container_ml' : 'container_all'">
      <div class="head">
        <navbar :list="breadcrumbs" :show="show" :collapse="isCollapse" @change="hideMenu" @personal="showPersonal" />
      </div>
      <div class="views">
        <transition mode="out-in" appear>
          <router-view />
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import navbar from "../components/navbar"

export default {
  components: { navbar },
  data() {
    return {
      active: "/",
      menuList: [],
      breadcrumbs: [],
      isCollapse: false,
      show: true,
    }
  },
  created() {
    this.menuList = this.$store.state.menuList
    this.initActive()
    this.setBreadcrumbs()
  },
  mounted() {
    window.addEventListener("resize", this.resizeHandler)
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.resizeHandler)
  },
  watch: {
    $route() {
      this.initActive()
      this.setBreadcrumbs()
    },
  },
  methods: {
    initActive() {
      if (this.$route.path == "/") {
        this.active = this.menuList[0].children[0].menuPath
        this.$router.replace(this.active)
      } else {
        if (!this.$route.path.includes("/detail/")) {
          this.active = this.$route.path
        }
      }
    },
    setBreadcrumbs() {
      // this.breadcrumbs = this.$route.matched.map(item => {
      //   return { name: item.meta.title, path: item.path }
      // })
      this.breadcrumbs = this.$route.matched.map(item => {
        let obj = {
          name: item.meta.title,
          path: item.path,
        }
        return obj
      })
    },
    // 监听窗口大小，显隐侧边栏
    resizeHandler() {
      if (window.innerWidth < 1280) {
        this.show = false
        this.isCollapse = true
      } else {
        this.show = true
        this.isCollapse = false
      }
    },
    // 显隐侧边栏
    hideMenu() {
      this.$nextTick(() => {
        this.isCollapse = !this.isCollapse
        this.show = !this.show
      })
    },
    showPersonal() {
      // this.$router.push('/personals');
      // this.active = ''
    },
  },
}
</script>

<style scoped lang="scss">
.main {
  width: 100%;
  height: 100%;

  .sidebar {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    width: 240px;
    height: 100%;
    background-color: $themes;
    overflow: auto;
    transition: all 0.3s ease-in-out;

    &::-webkit-scrollbar {
      width: 0;
      height: 0;
    }

    .logo {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      height: 80px;
      user-select: none;

      .logo_bg {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 65px;
        height: 65px;
        border-radius: 10px;
        background-color: #fff;
      }
    }

    .el_menus {
      width: 100%;
      border: none !important;

      .menuname {
        font-size: 15px;
      }

      // 已激活的菜单背景色
      .el-submenu {
        ::v-deep .el-menu,
        ::v-deep .el-menu-item {
          background: $themes2 !important;
        }
      }
      .is-opened {
        ::v-deep .el-submenu__title {
          background: $themes2 !important;
        }
      }

      ::v-deep .el-submenu__title i {
        color: #fff;
      }

      .el-menu-item.is-active {
        background-color: $themes3 !important;
      }

      ::v-deep .el-submenu__title:hover,
      ::v-deep .el-menu-item:hover {
        background: #d14d42 !important;
      }
    }

    .fold {
      color: #fff;
      text-align: center;
    }
  }

  .container {
    display: flex;
    flex-direction: column;
  }

  .container_ml {
    margin-left: 240px;
    transition: all 0.3s ease-in-out;
  }

  .container_all {
    margin-left: 0;
    transition: all 0.3s ease-in-out;
  }

  .views {
    height: 100%;
    min-height: calc(100vh - 2px - 80px - 70px);
    padding: 20px;
    margin: 10px;
    border-radius: 10px;
    border: 1px solid #e2e2e2;
    background-color: #fff;
  }

  .v-enter-active,
  .v-leave-active {
    transition: opacity 0.3s;
  }

  .v-enter,
  .v-leave-to {
    opacity: 0;
  }
}
</style>
